import { defineStore } from 'pinia'
import storage from '@/plugins/storage'
import http from '@/plugins/api.js'
// import { loading } from '@/plugins/loading'

const apiUrl = window.config ? window.config.apiUrl : ''

const TESTDRIVE_SEARCH_TERM = 'TESTDRIVE_SEARCH_TERM'
const TESTDRIVE_PAGE_SIZE = 'TESTDRIVE_PAGE_SIZE'
const TESTDRIVE_SORT_DIR = 'TESTDRIVE_SORT_DIR'
const TESTDRIVE_ORDER_BY = 'TESTDRIVE_ORDER_BY'
const TESTDRIVE_FILTER_BY = 'TESTDRIVE_FILTER_BY'

export const testdrives = defineStore('testdrives', {
  id: 'testdrives',
  state: () => ({
    default: {
      firm: 0,
      testdrive: null,
      testdriveType: 0,
      contact: 0,
      fleetNumber: '',
      insurance: 0,
      invoiceNumber: '',
      notes: '',
      ronumber: '',
      vehicle: {
        vehicle: -1,
        firm: 0,
        contact: 0,
        year: 2010,
        make: 0,
        model: '',
        vin: ''
      },
      createdBy: 0,
      status: 1
    },
    defaultDrive: {
      firm: 0,
      firmName: '',
      testDriveDrive: null,
      testDrive: null,
      roNumber: '',
      driveType: 0,
      driveTypeName: '',
      driveName: '',
      techs: [],
      distanceStart: 0,
      distanceEnd: 0,
      speedMin: 0,
      speedMax: 0,
      driveStart: new Date(),
      driveEnd: new Date(),
      technicianContact: 0,
      weather: null,
      notes: null,
      videoUrl: null
    },
    defaultWaypoint: {
      testdrivewaypoint: null,
      testdrivedrive: null,
      testdrive: null,
      time: new Date(),
      speed: 0,
      latitude: 0,
      longitude: 0
    },
    pageSize: storage.session.getItem(TESTDRIVE_PAGE_SIZE) || 10,
    searchTerm: storage.session.getItem(TESTDRIVE_SEARCH_TERM) || '',
    sortDir: storage.session.getItem(TESTDRIVE_SORT_DIR) || 'desc',
    orderBy: storage.session.getItem(TESTDRIVE_ORDER_BY) || 'TestDrive',
    filterBy: parseInt(storage.local.getItem(TESTDRIVE_FILTER_BY)) || 0,
    loading: {
      testdrives: false,
      testdrive: false,
      testdrivedrives: false,
      testdrivedrive: false,
      testdrivewaypoints: false,
      testdrivewaypoint: false,
      testdriveResults: false,
      testdriveMap: false,
      testdriveVideo: false
    },
    filterOptions: [],
    testdrives: [],
    testdrive: [],
    testdrivedrives: [],
    testdrivedrive: null,
    highlightSave: false,
    isTestDriveChecked: false,
    testdrivewaypoints: [],
    testdrivewaypoint: null,
    weather: null,
    videolink: null,
    testdriveTypeRates: [],
    testdriveResults: [],
    reportPreference: null,
    models: [],
    loadingDrive: false
  }),
  actions: {
    setSearchTerm(text) {
      this.searchTerm = text
      storage.session.setItem(TESTDRIVE_SEARCH_TERM, text)
    },
    setPageSize(pageSize) {
      this.pageSize = pageSize
      storage.session.setItem(TESTDRIVE_PAGE_SIZE, pageSize)
    },
    setSortDir(sortDir) {
      this.sortDir = sortDir
      storage.session.setItem(TESTDRIVE_SORT_DIR, sortDir)
    },
    setOrderBy(orderBy) {
      this.orderBy = orderBy
      storage.session.setItem(TESTDRIVE_ORDER_BY, orderBy)
    },
    setFilterBy(filterBy) {
      this.filterBy = filterBy
      storage.local.setItem(TESTDRIVE_FILTER_BY, filterBy)
    },
    setFilterOptions(data) {
      this.filterOptions = data
    },
    initTestdrive() {
      this.highlightSave = false
      this.testdrive = JSON.parse(JSON.stringify(this.default))
    },
    initTestdriveDrive() {
      this.highlightSave = false
      this.testdrivedrive = JSON.parse(JSON.stringify(this.defaultDrive))
    },
    initTestdriveWaypoint() {
      this.highlightSave = false
      this.testdrivewaypoint = JSON.parse(JSON.stringify(this.defaultWaypoint))
    },
    setTestdriveWaypoint(data) {
      this.testdrivewaypoint = data
    },
    updateTestdrive(data) {
      if (this.testdrive !== null && data !== null) {
        switch (data.name) {
          case 'firm':
            this.testdrive.firm = parseInt(data.value)
            this.testdrive.vehicle.firm = parseInt(data.value)
            break
          case 'contact':
            this.testdrive.contact = parseInt(data.value)
            this.testdrive.vehicle.contact = parseInt(data.value)
            break
          case 'testdriveType':
            this.testdrive.testdriveType = parseInt(data.value)
            break
          case 'insurance':
            this.testdrive.insurance = parseInt(data.value)
            break
          case 'fleetContact':
            this.testdrive.fleetContact = parseInt(data.value)
            break
          case 'ronumber':
            this.testdrive.ronumber = data.value
            break
          case 'invoiceNumber':
            this.testdrive.invoiceNumber = data.value
            break
          case 'fleetNumber':
            this.testdrive.fleetNumber = data.value
            break
          case 'vehicleYear':
            this.testdrive.vehicle.year = data.value
            break
          case 'vehicleMake':
            this.testdrive.vehicle.make = data.value
            break
          case 'vehicleModel':
            this.testdrive.vehicle.model = data.value
            break
          case 'vehicleVin':
            this.testdrive.vehicle.vin = data.value
            break
          case 'createdBy':
            this.testdrive.createdBy = data.value
            break
          case 'notes':
            this.testdrive.notes = data.value
            break
          case 'status':
            console.log('Updating Status', data)
            this.testdrive.status = parseInt(data.value)
            break
        }
      }
    },
    updateDrive(data) {
      if (this.testdrivedrive !== null && data !== null) {
        switch (data.name) {
          case 'firm':
            this.testdrivedrive.firm = parseInt(data.value)
            break
          case 'testdrive':
            this.testdrivedrive.testDrive = parseInt(data.value)
            break
          case 'driveName':
            this.testdrivedrive.driveName = data.value
            break
          case 'driveType':
            this.testdrivedrive.driveType = parseInt(data.value)
            break
          case 'techs':
            this.testdrivedrive.techs = []
            for (let i = 0; i < data.value.length; i++) {
              this.testdrivedrive.techs.push({
                id: data.value[i].id,
                name: data.value[i].name
              })
            }
            break
          case 'speedMin':
            this.testdrivedrive.speedMin = parseFloat(data.value)
            break
          case 'speedMax':
            this.testdrivedrive.speedMax = parseFloat(data.value)
            break
          case 'driveStart':
            this.testdrivedrive.driveStart = data.value
            break
          case 'driveEnd':
            this.testdrivedrive.driveEnd = data.value
            break
          case 'distanceStart':
            this.testdrivedrive.distanceStart = parseFloat(data.value)
            break
          case 'distanceEnd':
            this.testdrivedrive.distanceEnd = parseFloat(data.value)
            break
          case 'weather':
            this.testdrivedrive.weather = data.value
            break
          case 'notes':
            this.testdrivedrive.notes = data.value
            break
          case 'technicianContact':
            this.testdrivedrive.technicianContact = parseInt(data.value)
            break
          case 'videoUrl':
            this.testdrivedrive.videoUrl = data.value
            break
        }
      }
    },
    updateWaypoint(data) {
      if (this.testdrivedrive !== null && data !== null) {
        switch (data.name) {
          case 'testdrive':
            this.testdrivewaypoint.testdrive = parseInt(data.value)
            break
          case 'testdrivedrive':
            this.testdrivewaypoint.testdrivedrive = parseInt(data.value)
            break
          case 'latitude':
            this.testdrivewaypoint.latitude = parseFloat(data.value)
            break
          case 'longitude':
            this.testdrivewaypoint.longitude = parseFloat(data.value)
            break
          case 'time':
            this.testdrivewaypoint.time = data.value
            break
          case 'speed':
            this.testdrivewaypoint.speed = parseFloat(data.value)
            break
        }
      }
    },
    async getTestdriveTypeRates(firm) {
      const r = await http.get(`testdrive/testdriveTypeRates?firm=${firm}`)
      this.testdriveTypeRates = []
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.testdriveTypeRates = r.data
        }
      }
      return r.data
    },
    async saveTestdriveTypeRates(data) {
      const r = await http.post('testdrive/saveTestDriveTypeRates', data)
      return r.data
    },
    async getTestdrives(searchOptions) {
      this.loading.testdrives = true
      const r = await http.get('testdrive/testdrives', {
        params: searchOptions
      })
      this.testdrives = []
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.testdrives = r.data
        }
      }
      this.loading.testdrives = false
      return r.data
    },
    async getTestdrive(id) {
      this.loading.testdrive = true
      const r = await http.get(`testdrive/testdrive?id=${id}`)
      this.testdrive = []
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.testdrive = r.data
        }
      }
      this.loading.testdrive = false
      return r.data
    },
    async saveTestdrive(data) {
      const r = await http.post('testdrive/saveTestDrive', data)
      return r.data
    },
    async getTestdriveDrives(id) {
      this.loading.testdrivedrives = true
      const r = await http.get(`testdrive/drives?testdrive=${id}`)
      this.testdrivedrives = []
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.testdrivedrives = r.data
        }
      }
      this.loading.testdrivedrives = false
      return r.data
    },
    async getTestdriveDrive(id) {
      this.loading.testdrivedrive = true
      const r = await http.get(`testdrive/drive?id=${id}`)
      console.log('Setting Test Drive Drive', r.data)
      this.testdrivedrive = r.data
      this.loading.testdrivedrive = false
      return r.data
    },
    async getOwnerTestdrives(id) {
      this.loading.testdrives = true
      const r = await http.get(`testdrive/ownerTestdrives?contact=${id}`)
      this.testdrives = []
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.testdrives = r.data
        }
      }
      this.loading.testdrives = false
      return r.data
    },
    async saveTestdriveDrive(data) {
      const r = await http.post('testdrive/saveDrive', data)
      return r.data
    },
    async deleteTestdriveDrive(data) {
      const r = await http.post('testdrive/deleteDrive', data)
      return r.data
    },
    async getTestdriveWaypoints(id) {
      this.loading.testdrivewaypoints = true
      const r = await http.get(`testdrive/waypoints?testdrivedrive=${id}`)
      this.testdrivewaypoints = []
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.testdrivewaypoints = r.data
        }
      }
      this.loading.testdrivewaypoints = false
      return r.data
    },
    async getTestdriveWaypoint(id) {
      this.loading.testdrivewaypoint = true
      const r = await http.get(`testdrive/waypoint?id=${id}`)
      this.testdrivewaypoint = r.data
      this.loading.testdrivewaypoint = false
      return r.data
    },
    async saveTestdriveWaypoint(data) {
      const r = await http.post('testdrive/saveWaypoint', data)
      return r.data
    },
    async deleteTestdriveWaypoint(data) {
      const r = await http.post('testdrive/deleteWaypoint', data)
      return r.data
    },
    async getTestDriveMap(data) {
      this.loading.testdriveMap = true
      const r = await http.get(`report/drivemap?testdrivedrive=${data.testdrivedrive}&refresh=${data.refresh}`)
      this.loading.testdriveMap = false
      return r.data
    },
    async sendReport(report) {
      const r = await http.get(`report/send${report.report}?testdrivedrive=${report.testdrivedrive}`)
      return r.data
    },
    async getRecommendations(options) {
      const r = await http.get('testdrive/testdriveRecommendations', {
        params: options
      })
      return r.data
    },
    async shortenUrl(data) {
      const r = await http.post('ShortenUrl', data)
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.testdrivedrive.videoUrl = `${apiUrl}/${data}`
        }
      }
      return r.data
    },
    async getWeatherById(weather) {
      const r = await http.get(`testdrive/weather?weather=${weather}`)
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.weather = r.data
        }
      }
      return r.data
    },
    async getVideo(id) {
      this.loading.testdriveVideo = true
      const r = await http.get(`testdrive/videolink?id=${id}`)
      this.videolink = null
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.videolink = r.data
        }
      }
      this.loading.testdriveVideo = false
      return r.data
    },
    async getTestdriveResults(testdrivedrive) {
      this.loading.testdriveResults = true
      const r = await http.get(`testdrive/driveResults?testdrivedrive=${testdrivedrive}`)
      this.testdriveResults = []
      if (r.data !== undefined && r.data !== null) {
        if (r.data !== '') {
          this.testdriveResults = r.data
        }
      }
      this.loading.testdriveResults = false
      return r.data
    },
    async saveTestdriveResults(data) {
      const r = await http.post('testdrive/saveDriveResults', data)
      return r.data
    },
    async getReportPreference(testdrivedrive) {
      const r = await http.get(`report/reportPreference?testdrivedrive=${testdrivedrive}`)
      this.reportPreference = r.data
      return r.data
    },
    async getModel(data) {
      const r = await http.get(`models/models?makeId=${data}`)
      this.models = r.data
      return r.data
    },
    async getPresigedUrl(firm, fileName) {
      const r = await http.get(`firm/presignedUrl?firm=${firm}&filename=${fileName}`)
      if (this.testdrivedrive !== undefined && this.testdrivedrive !== null) {
        this.testdrivedrive.videoUrl = r.data
      }
      return r.data
    }
  }
})
